import clsx from "clsx";
import type dayjs from "dayjs";
import type { ForwardedRef} from "react";
import { forwardRef } from "react";

interface DateRangePickerInputLikeProps {
  focused?: boolean;
  day?: dayjs.Dayjs;
  placeholder?: string;
}

function DateRangePickerInputLikeComp(
  { focused, day, placeholder, ...props }: DateRangePickerInputLikeProps,
  ref: ForwardedRef<HTMLButtonElement>
) {
  return (
    <button
      {...props}
      type="button"
      ref={ref}
      className={clsx(
        "relative",
        "block",
        "font-sans",
        "text-[16px]",
        "text-left",
        "text-gray-900",
        "w-full",
        "p-2",
        "outline-none",
        "transition-shadow",
        "duration-150",
        focused && [
          "before:absolute",
          "before:bottom-0",
          "before:left-0",
          "before:w-full",
          "before:h-[2px]",
          "before:bg-blue-600",
        ]
      )}
    >
      {day ? (
        <span className={clsx("text-gray-900", "pointer-events-none")}>{day.format("YYYY年M月D日")}</span>
      ) : (
        <span className={clsx("text-gray-400", "select-none", "cursor-default", "pointer-events-none")}>
          {placeholder}
        </span>
      )}
    </button>
  );
}

export const DateRangePickerInputLike = forwardRef(DateRangePickerInputLikeComp);
